'use client'

import useIsMobile from '@/hooks/useIsMobile'
import { GoalProps } from '@/widgets/landing-page-widgets/hero-section/schema'
import { cn } from '@admin/lib/utils'
import { CheckCircleIcon } from '@heroicons/react/24/solid'
import { Typography } from '@pw-tech/omni-ui'
import Image from 'next/image'


const GoalSelectionCard = ({
  data,
  selectedGoal,
  handleGoalSelection,
}: {
  data: GoalProps
  selectedGoal: GoalProps
  handleGoalSelection: (x: GoalProps) => void
}) => {
  const { isMobile } = useIsMobile()
  const isSelected = data?.cohortId === selectedGoal?.cohortId

  return (
    <div
      className={cn(
        'md:p-4 p-3 text-greyPallete-900 rounded-xl md:rounded-2xl cursor-pointer flex flex-row md:block',
        isSelected
          ? 'border border-[#ff6d0a]'
          : 'md:border border-[#EFEFEF]'
      )}
      style={data?.color ? {
        background: data.color,
      } : undefined}
      tabIndex={0}
      role='button'
      onClick={() => handleGoalSelection(data)}
    >
  <div className="md:h-[138px] h-[78px] min-w-[78px] md:w-full rounded-lg overflow-hidden relative">
        <Image
          src={data?.thumbnail}
          layout='fill'
          objectFit='cover'
          objectPosition='center'
          alt={data.title}
        />
      </div>

      <div className="gap-1 md:gap-2 md:mt-2 md:flex md:flex-col md:justify-between justify-start ml-2 md:ml-0">
        <h2 className="flex-1 flex flex-row justify-between items-center">
          <Typography variant='heading4' component='span' weight='bold'>
            {data.title}
          </Typography>
          {isSelected && (
            <div className={cn('md:min-w-[24px] min-w-[20px]')}>
              <CheckCircleIcon width={isMobile ? 20 : 24} height={isMobile ? 20 : 24} color='#FF6D0A' />
            </div>
          )}
        </h2>
        <Typography variant='small'>{data.description}</Typography>
      </div>
    </div>
  )
}

export default GoalSelectionCard
